<template>
  <div>
    <div class="row1" style="padding-right: 10px;">
      <div>
		  <div style="margin-bottom: 3px;">
		    <el-button
		      @click="onAdd"
		      class="row-btn add"
			  style="width: 100px;margin-bottom: 4px;"
		      type="primary"
		      size="small"
		      >站点录入</el-button
		    >
		    <!-- <el-button
		      @click="onReserve"
		      class="row-btn add"
		      type="primary"
		      size="small"
		      >预留</el-button
		    > -->
		    <el-button
		      @click="onDel"
		      class="row-btn del"
		  		  style="width: 100px;margin-left: 0;"
		      type="primary"
		      size="small"
		      >删除</el-button
		    >
		  </div>
		  <div>
		    <el-button
		      @click="onAddPoints"
		      class="row-btn add join-btn"
			  style="width: 100px;margin-bottom: 4px;"
		      type="primary"
		      size="small"
		      >加入点位库</el-button
		    >
		    <el-button
		      @click="onMyPoints"
		      class="row-btn add"
			  style="width: 100px;margin-left: 0;"
		      type="primary"
		      size="small"
		      >点位库</el-button
		    >
		  </div>
	  </div>
      <div class="top-right-box">
        <div class="top-row1 dis-flex">
          <div class="el-input-top1">
            <div class="el-top-select1">
              <div>
				  <span>周边:</span>
				  <el-select size="small" v-model="value" placeholder="请选择">
				    <el-option
				  				@visible-change="onblur1"
				     v-for="(v,k) in options"
				    :key="k"
				  				name="name"
				    :label="v.name"
				    :value="v.id"
				      disabled
				      class="txt-btn"
				      style="
				        cursor: pointer !important;
				        overflow: visible !important;
				        height: auto !important;
				        width: 230px !important;
				        display: flex !important;
				        flex-wrap: wrap !important;
				        padding-bottom:12px;">
				        <div style="color:#606266">{{v.name}}</div>
				  					<div style="color:#606266" 
				  					:style="[tagStyle,allTag,v.check == true?selTag:noselTag]"
				  					@click="tagAll(v,k)">全选</div>
				        <div
				          style="
				            width: 230px;
				            display: flex !important;
				            flex-wrap: wrap !important;">
				          <span
				            :style="[tagStyle,item.check == true?selTag:noselTag]"
				            ref="zbTag"
				            @click="onSelectTag(item,k,key)"
				            v-for="(item,key) in v.children"
				            :key="key"
				            >{{item.name}}</span>
				        </div>
				    </el-option>
				  </el-select>
			  </div>
            </div>
          </div>
          <div class="el-input-top">
			<span>区域:</span>
			<el-input
			style="width: auto;margin-left: 5px;"
			  size="small"
			  clearable
			  width="50"
			  placeholder="请输入区域"
			  v-model="searchObj.district"
			></el-input>
          </div>
		 <div class="el-input-top" style="margin-left: 10px;">
			<span>新编号:</span>
			<el-input
			style="width: auto;margin-left: 5px;"
			  size="small"
			  clearable
			  width="50"
			  placeholder="请输入新编号"
			  v-model="searchObj.new_number"
			></el-input>
		  </div>
		  <div class="el-input-top">
		  	<span style="margin-left: 5px;">级别:</span>
		  	<el-select size="small" v-model="searchObj.grade" placeholder="请选择级别">
				<el-option value="" label="全部"></el-option>
		  		<el-option :value="k" :label="v" v-for="(v,k) in rObj.grade" :key="k">{{v}}</el-option>
		  	</el-select>
		  </div>
          <div class="el-input-top">
			  <span>&nbsp;</span>
            <el-input
			style="width: auto;"
              size="small"
              clearable
              width="50"
              placeholder="搜索站点名称"
              suffix-icon="el-icon-search"
              v-model="searchObj.name"
            >
            </el-input>
          </div>
        </div>
        <div class="dis-flex">
          <div>
            <span style="font-size: 15px; margin-right: 6px">上画时间:</span>
            <el-date-picker
              v-model="date"
              size="small"
              type="daterange"
			  value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始月份"
              end-placeholder="结束月份"
			  @change="changeDate"
            >
            </el-date-picker>
          </div>
          <div class="el-select1">
            <div>
				<span>方位:</span>
				<el-select size="small" v-model="searchObj.direction" placeholder="请选择方位">
					<el-option value="" label="全部"></el-option>
				  <el-option :value="k" :label="v" v-for="(v,k) in rObj.direction" :key="k">{{v}}</el-option>
				</el-select>
			</div>
          </div>
		  <div class="el-select1">
			   <span>亮灯:</span>
			   <el-select  size="small" v-model="searchObj.light" placeholder="是否亮灯">
				   <el-option value="" label="全部"></el-option>
				 <el-option :value="k" :label="v" v-for="(v,k) in rObj.light" :key="k">{{v}}</el-option>
			   </el-select>
		  </div>
          <div class="el-select2">
            <span>投放形式:</span>
            <el-select
              size="small"
              v-model="searchObj.scroll"
              placeholder="请选择投放形式"
            >
			  <el-option value="" label="全部"></el-option>
              <el-option :value="k" :label="v" v-for="(v,k) in rObj.scroll" :key="k">{{v}}</el-option>
            </el-select>
          </div>
		  <div class="el-select2" style="margin-left: 5px;">
		    <span >类型:</span>
		    <el-select
		      size="small"
		      v-model="searchObj.category"
		      placeholder="请选择类型">
			  <el-option value="" label="全部"></el-option>
		      <el-option :value="k" :label="v" v-for="(v,k) in rObj.category" :key="k">{{v}}</el-option>
		    </el-select>
		  </div>
          <el-button
            @click="onSearch"
            class="row-btn add search"
			style="width: 100px;"
            type="primary"
            size="small"
            >搜索</el-button
          >
        </div>
      </div>
    </div>
    <div class="tab-box">
      <el-table
        border
        :span-method="arraySpanMethod"
        v-loading="loading"
        element-loading-text="加载中"
        :header-cell-style="{ background: '#F6F6F6', color: '#606266' }"
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection"></el-table-column>

        <el-table-column label="站点信息" align="center" width="350">
          <template slot-scope="scope">
            <span v-if="!scope.row.flag" v-html="scope.row.name"></span>
            <div v-else>
             <img v-if="scope.row.flag"
                class="icon-img"
                :src="scope.row.tagImg"
                alt=""
                srcset=""
              />
              <div class="dis-flex">
                <div>
                  <el-image
					v-if="scope.row.flag"
                    style="width: 120px; height: 80px"
                    :src="scope.row.imgs[0]"
                    :preview-src-list="scope.row.imgs"
                  >
                  </el-image>
                </div>
                <div style="padding: 0 20px; font-size: 13px">
                  {{scope.row.size}}
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
		<!-- <el-table-column prop="new_number" label="新编号"> </el-table-column> -->
        <el-table-column prop="name" label="站名"> </el-table-column>
		<!-- <el-table-column prop="brand" label="品牌"> </el-table-column> -->
        <el-table-column label="类型">
			<template slot-scope="scope">
			  <div v-if="scope.row.flag == 1">{{ scope.row.category.text }}</div>
			</template>
		</el-table-column>
        <el-table-column label="位置" width="130">
          <template slot-scope="scope" >
            <div>路段：{{scope.row.street}}</div>
            <div>区域：{{scope.row.district}}</div>
            <div class="handle-box">
              <el-tooltip
                class="item"
                effect="dark"
                placement="top"
              >
			  <div slot="content">{{scope.row.address}}</div>
                <span
                  class="txt-btn txtC"
                  @click="handleDetail(scope.$index, scope.row)"
                  >查看详细地址</span
                >
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="备注">
          <template slot-scope="scope">
            <div class="dis-flex al-center">
              <span class=""
                >{{scope.row.remark}}</span
              >
              <i
                @click="editRemarks(scope.row)"
                style="margin-left: 6px"
                class="el-icon-edit txtC txt-btn"
              ></i>
			  <br/>
            </div>
			<div class="dis-flex al-center">
			<span class="" >{{scope.row.is_disable?'被禁用:'+scope.row.disable_reason:''}}</span>
			</div>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="工程">
          <template slot-scope="scope"  v-if="scope.row.flag == 1">
            <div>挂画人：{{ scope.row.hang.name }}</div>
			<div>拍照人：{{ scope.row.photographer.name }}</div>
            <div>仓库：{{ scope.row.warehouse.text }}</div>
          </template>
        </el-table-column>
        <el-table-column label="周边" width="200">
          <template slot-scope="scope">
            <el-tooltip
              v-for="(i, k) in scope.row.periphery"
              :key="k"
              class="item"
              effect="light"
              placement="top" >
			  <div slot="content" v-if="i.children">
			  	<div class="txt-btn txtC tag tag2 borderM" v-for="(itemi,keyi) in i.children" :key="keyi">{{itemi.name}}</div>
			  </div>
			  <div slot="content" v-else>
			  	<div class="txt-btn txtC borderM">无</div>
			  </div>
              <div class="txt-btn txtC tag borderM"
                @click="handleDetail(scope.$index, scope.row)">
                {{i.name}}
              </div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="销售情况">
          <template slot-scope="scope">
            <div>{{scope.row.order_count == 0?'未售出':'已售出'}}</div>
            <div class="txtC txt-btn" v-if="scope.row.order_count != 0">
              <span @click="kqDetail(scope.row)" class="look-kq">查看刊期</span>
            </div>
			<div class="txtC txt-btn">
			  <span @click="ylDetail(scope.row)" class="look-kq">查看预留</span>
			</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150" align="center">
          <template slot-scope="scope">
            <div class="handle-box">
              <span
                class="txt-btn txtC"
                @click="handleEdit(scope.row)"
                >编辑</span
              >
			  <span
			    class="txt-btn txtC"
			    @click="handleDisable(scope.row)"
			    >{{scope.row.is_disable?'解除禁用':'禁用'}}</span
			  >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="page-box">
        <el-pagination
		 v-if="tableData.length"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[5,10,20,50,100]"
          :page-size="10"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <!-- 修改备注弹框 -->
    <el-dialog :title="remarkTitle" :visible.sync="dialogFormVisible" width="25%">
      <el-form>
        <el-form-item label="备注内容">
          <el-input
            v-model="editRemarksVal"
            autocomplete="off"
            placeholder="请输入备注内容"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="onEditRemark"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <!-- 查看刊期弹框 -->
    <tab-dialog
      :tabData="kqTabData"
      title="查看刊期"
      ref="moreDialog"
    ></tab-dialog>
    <!-- 加入点位库选择预留日期 -->
	<el-dialog title="预留" :visible.sync="dialogYL" width="25%">
	  <el-form>
	    <el-form-item label="预留日期">
	      <el-date-picker
	        v-model="dateYL"
	        size="small"
	        type="daterange"
	        value-format="yyyy-MM-dd"
	        range-separator="至"
	        start-placeholder="开始月份"
	        end-placeholder="结束月份"
	      > </el-date-picker>
	    </el-form-item>
	  </el-form>
	  <div slot="footer" class="dialog-footer">
	    <el-button @click="dialogYL = false">取 消</el-button>
	    <el-button type="primary" @click="onYl"
	      >确 定</el-button
	    >
	  </div>
	</el-dialog>
	<!-- 预留弹框 -->
    <reserve-dg ref="reserve" @onreserve="handleReserve"></reserve-dg>
  </div>
</template>

<script>
import tabDialog from "../../components/dialog/order/more.vue";
import reserveDg from "../../components/dialog/site/reserve.vue";
export default {
  components: {
    tabDialog,
    reserveDg
  },
  data() {
    return {
		remarkTitle:'修改备注',
		dateYL:'',
		dialogYL:false,
      tagStyle:{
        marginTop: '7px',
        lineHeight: '21px',
        display: 'inline-block',
        padding: '0 10px !important',
        borderRadius: '2px',
        marginRight: '10px',
      },
	  allTag:{
		  lineHeight: '22px',
		  height:'22px',
		  marginTop: '5px',
		  marginLeft:'10px'
	  },
      selTag:{
        color:'#409EFF',
        border: '1px solid #409EFF',
      },
      noselTag:{
        color:'#C0C4CC',
        border: '1px solid #C0C4CC',
      },
      options: [
        // {
        //   label: "热门城市",
        //   options: [
        //     {
        //       value: "Shanghai",
        //       label: "上海",
        //       flag:false
        //     },
        //     {
        //       value: "Beijing",
        //       label: "北京",
        //       flag:false
        //     },
        //   ],
        // }
      ],
      tagArr:[],
      value: "",
	  date:'',
      // 搜索数据对象
      searchObj: {
        light: "",//亮灯情况
		scroll: "",//投放形式
		direction: "",//方位
		grade: "",//等级
		name: "",//关键字
		// periphery: [],//周边标签
		district:'',//区域
		new_number:'',//品牌
		category:''//类型
      },
      editRemarksVal: "", //备注内容
      dialogFormVisible: false,
      tableData: [
        // {
        //   name: '大虎\u3000\u3000\u3000小虎<i class="el-icon-s-opportunity" style="color:#FF7062;"></i>',
        // },
        // {
        //   date: "2",
        //   name: "王小虎",
        //   img: "https://cdn.uviewui.com/uview/album/1.jpg",
        //   address: "上海市普陀区金沙",
        // }
      ],
	  pageObj: {
	  	limit: 10,
	  	page: 1,
		filter: {},
		op: {},
		periphery:[]
	  },
	  total: 0, //总条数
      multipleSelection: [], //勾选的数据
      currentPage: 1, //当前页
      loading: true, //是否显示加载中图标
      //刊期弹框中表格数据
      kqTabData: [
        { name: "序号", prop: "date" },
        { name: "客户名称", prop: "name" },
        { name: "上画时间", prop: "date" },
        { name: "下画时间", prop: "date" },
        { name: "到期时间", prop: "date" },
      ],
	  remarkObj:{},
	  rObj:{
	  	direction:[],
	  	grade:[],
	  	scroll:[],
	  	warehouse:[],
	  	light:[],
	  	category:[],
	  	user:[]
	  },
	  isEditback:false,
	  isSearch:false,
	  conditionObj:{},
	  advertiseDisable:false,
	  disableObj:{}
    };
  },
  created() {
	  let conditionObj = localStorage.getItem('conditionObj')
	  if(conditionObj){
		  conditionObj = JSON.parse(conditionObj)
		  if(conditionObj.pageObj){
			  this.pageObj = conditionObj.pageObj
		  }
		  if(conditionObj.searchObj){
			  this.searchObj = conditionObj.searchObj
		  }
		  if(conditionObj.options){
			  this.options = conditionObj.options
		  }
	  }
	  // this.currentPage = this.pageObj.page
	  this.getList();
	  this.getConfig()
  },
  methods: {
	  handleDisable(row){
		  if(row.is_disable){
			  //取消
			  this.$api2.advertiseDisable({id:row.id,reason:''}).then(res => {
				  this.$message.success(res.msg);
				  this.getList();
			  })
		  }else{
			  //拉起禁用
			  this.remarkTitle = '点位禁用备注';
			  this.dialogFormVisible = true;
			  this.advertiseDisable = true;
			  this.disableObj = {
				  id:row.id
			  }
		  }
	  },
	  
	  changeDate(e){
		  console.log(this.searchObj.date);
		  this.pageObj.start_time = this.date[0]
		  this.pageObj.end_time = this.date[1]
	  },
	
	//加入点位库
	onAddPoints(){
		if (!this.multipleSelection.length) return this.$message.error("请勾选要加入的选项！");
		this.dialogYL = true;
	},
	//确认加入点位库
	onYl(){
		let ids = []
		this.multipleSelection.forEach((v,k)=>{
			if(v.id){
				ids.push({
					id:v.id,
					start_time:this.dateYL[0],
					end_time:this.dateYL[1],
				})
			}
		})
		
		let myPoints = localStorage.getItem('myPoints')
		if(myPoints){
			myPoints = JSON.parse(myPoints)
			ids.forEach((item,key)=>{
				myPoints.unshift(item)
			})
		}else{
			myPoints = ids
		}
		let newMyPoints = this.unique(myPoints,'id')
		localStorage.setItem('myPoints',JSON.stringify(newMyPoints))
		this.$message.success('添加成功')
		this.dialogYL = false;
	},
	// 对象数组根据属性值去重
	unique(arr, key) {
	    const map = new Map()
	    return arr.filter((item) => !map.has(item[key] + '') && map.set(item[key] + '', 1))
	},
	// 点位库
	onMyPoints(){
		let myPoints = localStorage.getItem('myPoints')
		if(myPoints){
			myPoints = JSON.parse(myPoints)
			if(!myPoints.length){
				this.$message.error('暂无点位，请添加！')
				return
			}
		}
		this.$router.push({name:'myPoints'})
	},
	handleEdit(v){
		let obj = JSON.stringify(v)
		this.conditionObj.pageObj = this.pageObj;
		this.conditionObj.options = this.options
		this.conditionObj.searchObj = this.searchObj
		localStorage.setItem('conditionObj',JSON.stringify(this.conditionObj))
      this.$router.push({ 
		  path: "/addSite",
		  query: {obj:obj}});
    },
    handleReserve(){

    },
	// 周边下拉框失焦点
	onblur1(){
		console.log(this.options);
	},
	//点击全选
	tagAll(v,k){
		this.tagArr = []
		this.options[k].children.forEach((item,index)=>{
			this.options[k].children[index].check = v.check == true?false:true;
		})
		this.options[k].check = v.check == true?false:true;
		this.options.forEach((vva,kke)=>{
			this.options[kke].children.forEach((vv,kk)=>{
				if(vv.check){
					console.log(vv.check);
					this.tagArr.push(vv.name) 
				}
			})
		})
		this.value = this.tagArr
	},
    // 点击周边下拉框中的标签
    onSelectTag(item,k,key) {
		this.tagArr = []
      this.options[k].children[key].check = item.check == true?false:true;
	  if(item.check == false){
	  	this.options[k].check = false
	  }
	  let i = 0;
	  this.options[k].children.forEach((va,ke)=>{
	  	if(va.check){
	  		i += 1;
	  	}
	  })
	  // 本项标签全选时情况
	  if(i == this.options[k].children.length){
	  	this.options[k].check = true;//全选变颜色
		console.log(this.options[k]);
	  }
	  this.options.forEach((vva,kke)=>{
	  	this.options[kke].children.forEach((vv,kk)=>{
	  		if(vv.check){
	  			console.log(vv.check);
	  			this.tagArr.push(vv.name) 
	  		}
	  	})
	  })
	  this.value = this.tagArr
    },
    //查看刊期弹框
    kqDetail(item) {
		this.$refs.moreDialog.pageObj2.advertise_id = item.id
		this.$refs.moreDialog.pageObj2.limit = 10
		this.$refs.moreDialog.pageObj2.page = 1
		this.$api2.indexOrder(this.$refs.moreDialog.pageObj2).then((res)=>{
			if(res.code == 1){
				this.$refs.moreDialog.tableData = res.data
				this.$refs.moreDialog.total = res.count
				this.$refs.moreDialog.dialogVisible = true;
			}else{
				this.$message.error(res.msg)
			}
		})
    },
	//查看预留弹框
	ylDetail(item) {
		this.$refs.moreDialog.pageObj2.advertise_id = item.id
		this.$refs.moreDialog.pageObj2.limit = 10
		this.$refs.moreDialog.pageObj2.page = 1
		this.$api2.reserveOccupy(this.$refs.moreDialog.pageObj2).then((res)=>{
			if(res.code == 1){
				this.$refs.moreDialog.tableData = res.data
				this.$refs.moreDialog.total = res.count
				this.$refs.moreDialog.dialogVisible = true;
			}else{
				this.$message.error(res.msg)
			}
		})
	},
	//修改备注
	onEditRemark(){
		if(this.advertiseDisable){
			//点位禁用并填写备注
			this.disableObj.reason = this.editRemarksVal;
			this.$api2.advertiseDisable(this.disableObj).then(res => {
				this.$message.success(res.msg);
				this.dialogFormVisible = false;
				this.getList();
			})
		}else{
			//点位备注
			this.remarkObj.value = this.editRemarksVal;
			this.$api2.modifyAdvertise(this.remarkObj).then((res)=>{
				if(res.code == 1){
					this.getList()
					this.dialogFormVisible = false;
					this.$message.success(res.msg)
				}else{
					this.$message.error(res.msg)
				}
			})
		}
	},
    // 修改备注弹框
    editRemarks(v) {
		this.remarkTitle = '修改备注';
		this.remarkObj.id = v.id;
		this.remarkObj.field = 'remark';		
		this.editRemarksVal = v.remark
		this.dialogFormVisible = true;
		this.advertiseDisable = false;
    },
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      if (rowIndex % 2 === 0) {
        if (columnIndex === 0) {
          return [0, 0];
        } else if (columnIndex === 1) {
          return [1, 12];
        }
      }
    },
    //搜索
    onSearch() {
		if(!this.date){
			this.pageObj.start_time = ''
			this.pageObj.end_time = ''
		}
		this.conditionObj.pageObj = this.pageObj;
		this.isSearch = true;
		// if(!this.isEditback){
			this.pageObj.page = 1
			this.currentPage = 1
			this.pageObj.periphery = []
		// }
		this.options.forEach((v,k)=>{
			if(v.check){
				this.pageObj.periphery.push(v.id)
			}else{
				this.options[k].children.forEach((val,key)=>{
					if(val.check){
						this.pageObj.periphery.push(val.id)
					}
				})
			}
		})
		for(let key in this.searchObj){
			this.pageObj.filter[key] = this.searchObj[key].toString()
			if(key == 'name'){
				this.pageObj.op[key] = '%*%'
			} else {
				// console.log(key);
				this.pageObj.op[key] = '='
			}
		}
		this.pageObj.periphery = this.pageObj.periphery.toString()
		this.conditionObj.options = this.options
		this.conditionObj.searchObj = this.searchObj;
		this.getList()
		console.log(this.pageObj);
	},
    // 添加
    onAdd() {
      this.$router.push({ path: "/addSite" });
      console.log("添加");
    },
    //预留弹框
    onReserve(){
      if (!this.multipleSelection.length) return this.$message.error("请勾选要预留的选项！");
      this.$refs.reserve.dialogVisible = true;
    },
    //删除
    onDel() {
      if (!this.multipleSelection.length) return this.$message.error("请勾选要删除的选项！");
	  let ids = []
	  this.multipleSelection.forEach((v,k)=>{
	  	ids[k] = v.id
	  })
	  this.$confirm('确认删除？', '提示').then(() => {
	  	this.$api2.deleteAdvertise({id:ids}).then((res)=>{
	  		if(res.code == 1){
	  			this.$message.success(res.msg)
	  			this.getList()
	  		}else{
	  			this.$message.error(res.msg)
	  		}
	  	})
	  }).catch(()=>{})
    },
    // 获取数据列表
    getList() {
		this.loading = true;
      this.$api2.advertiseList(this.pageObj).then(res => {
      	this.loading = false;
      	if (res.code == 1) {
			this.currentPage = this.pageObj.page
			localStorage.removeItem('conditionObj')
      		this.total = res.count;
			this.tableData = res.data;
			this.tableData.forEach((v,k)=>{
				if(v.flag){
					this.tableData[k].tagImg = this.$baseUrl+'/images/grade/'+v.grade.text+'.png'
					// 预览图片数组
					this.tableData[k].imgs = []
					v.images.forEach((vv,kk)=>{
						if(vv.url){
							this.tableData[k].imgs.push(vv.url)
						}
					})
				}
			})
      	}
      })
      .catch(err => {
      	this.loading = false;
      });
    },
	//配置信息
	getConfig() {
		this.$api2.getConfig().then(res => {
			if (res.code == 1) {
				this.rObj.scroll = res.data.enum.scroll;
				this.rObj.light = res.data.enum.light;
				this.rObj.grade = res.data.enum.grade;
				this.rObj.warehouse = res.data.enum.warehouse;
				this.rObj.direction = res.data.enum.direction;
				this.rObj.category = res.data.enum.category;
				this.options = res.data.enum.periphery
			
			}
		});
	},
    // 多选事件
    handleSelectionChange(val) {
      this.multipleSelection = val;
      console.log(val);
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
	  this.pageObj.limit = val;
	  this.getList();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
	  this.pageObj.page = val;
	  this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/public.scss";
.join-btn{
	padding: 10px;
}
.tag {
  margin: 5px;
  font-size: 12px;
  display: inline-block;
  padding: 0 4px;
  border-radius: 3px;
  border: 1px solid #004f9d !important;
}
.tag2{
	padding: 2px 5px;
}

.look-kq {
  border-bottom: 1px solid #004f9d;
}
.row1 /deep/ {
  align-items: center;
  justify-content: space-between;
  .top-right-box {
    // margin-top: -50px;
  }
  .el-date-editor {
    width: 225px;
  }
  .el-select {
    margin-left: 8px;
  }
  .el-input__inner {
    padding-left: 10px;
    margin-right: 10px;
  }
  .el-select1 {
    .el-select {
      width: 110px;
      margin-right: 10px;
    }
  }
  .el-select2 {
    .el-select {
      // width: 150px;
    }
  }
  .top-row1 {
    margin-bottom: 10px;
	display: flex;
	justify-content: end;
  }
  .el-input-top1 {
    .el-select {
      margin-right: 10px;
      width: 200px;
    }
    .el-top-select1 {
      .el-select {
        margin-left: 5px;
      }
    }
  }
  .el-input-top2 {
    .el-select,
    .el-input {
      margin-right: 10px;
      margin-left: 0px;
      width: 170px;
    }
    .el-input {
      margin-left: 10px;
    }
  }
}
.search {
  margin-left: 20px !important;
  margin-right: 0 !important;
}
.handle-box {
  padding: 0 10px;
  display: flex;
  justify-content: space-around;
}
//    /dedp/  解决scoped中组件样式不生效
.tab-box /deep/ {
  .has-gutter {
    .cell {
      text-align: center !important;
    }

    .el-table__cell {
      // background-color: red;
      border: none !important;
    }
  }
  .el-table__row:nth-child(2n) {
    margin-bottom: 20px;
    .el-table_1_column_1 {
      border-right: none !important;
    }
    .cell {
      text-align: center !important;
    }
  }
  .el-table__row:nth-child(2n - 1) {
    text-align: left !important;
    .cell {
      line-height: 0px;
      padding-left: 30px !important;
      .tag {
        margin: 0;
      }
    }
  }
  .el-table__cell:nth-child(2n-1) {
    text-align: left !important;
  }
}
.icon-img {
  position: absolute;
  left: -48px;
  top: 0px;
  height: 30px;
  width: 30px;
}
</style>